import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import axios from 'axios';
import { environment } from 'environments/environment';
import { UsersApi } from 'shared/sdk';
import { PreloaderService } from 'shared/services/preloader.service';

@Component({
  selector: 'app-user-preference-content',
  templateUrl: './user-preference-content.component.html',
  styleUrls: ['./user-preference-content.component.css']
})
export class UserPreferenceContentComponent implements OnInit {
  content: any;
  userConsentform: FormGroup;
  message='';
  appData:any;
  @ViewChild('mobile_number') mobileNumber: any;
  @Output() cancel: EventEmitter<boolean> = new EventEmitter;
  mobileNo = '';
  constructor( private fb: FormBuilder,
    private _usersApi :UsersApi,
    private _preloaderService: PreloaderService
  ) { 
    this.appData = JSON.parse(localStorage.getItem('appData'));
    
  }

  ngOnInit() {
     this.userConsentform = this.fb.group({
      sms: [null, Validators.required],//, Validators.required
      whatsapp: [null],
      mobileNo: [null, Validators.required]
    });
    axios.get(environment.baseUrl + '/api/content/user-preferences-consent').then(res => {
      this.content = res.data.data;
    });
    this.setFormData();
     
  }

  submit() {
    if(!this.mobileNumber.valid){
      return false;
    }
    if (this.userConsentform.invalid) {
      alert('Please select options');
      return;
    }
    let smsValue = null;
    let whatsappValue = null;
    if(this.userConsentform.value.sms=='yes'){
      smsValue = true;
    }else if(this.userConsentform.value.sms=='no'){
      smsValue = false;
    }
    ///
    if(this.userConsentform.value.whatsapp=='yes'){
      whatsappValue = true;
    }else if(this.userConsentform.value.whatsapp=='no'){
      whatsappValue = false;
    }

    const payload = {
      sms:smsValue,
      whatsapp:whatsappValue,
      mobile_number: this.mobileNo
    };
    const prefs = this.appData.user.preferences || {};
    this.appData.user.preferences = {
      ...prefs,
      ...payload
    };

    this._preloaderService.showPreloader();
    this._usersApi.saveUserPreference({ data: payload, id: this.appData.user.id }).subscribe(res => {      
      localStorage.setItem('appData', JSON.stringify(this.appData));
      this._preloaderService.hidePreloader();
      this.message = res;     
      this.cancel.emit(true);
    },err=>{
      this._preloaderService.hidePreloader();      
    });
  }

  setFormData(){
    this.mobileNo = (this.appData && this.appData.user && this.appData.user.preferences &&this.appData.user.preferences.mobile_number) || (this.appData && this.appData.user && this.appData.user.contact && this.appData.user.contact.MobilePhone ? this.appData.user.contact.MobilePhone : '');
    if (this.mobileNo) {
      this.userConsentform.get('mobileNo').setValue(this.mobileNo);
    }
    const prefs = this.appData.user.preferences || {};
    const requiredKeys = ['sms', 'whatsapp'];
    const allKeysExist = requiredKeys.every(
      key => key in prefs
    );
    if (allKeysExist) {
    let smsValue = null;
    let whatsappValue = null;
      if(prefs.sms==true){
        smsValue = 'yes';
      }else if(prefs.sms==false){
        smsValue = 'no';
      }
      ///
      if(prefs.whatsapp==true){
        whatsappValue = 'yes';
      }else if(prefs.whatsapp==false){
        whatsappValue = 'no';
      }
      this.userConsentform.get('sms').setValue(smsValue);
      this.userConsentform.get('whatsapp').setValue(whatsappValue);
    }


  }

  onPhoneNumberUp(e) {
    this.userConsentform.markAsDirty();
    const ctrl = this.userConsentform.get('mobileNo');
    if (this.mobileNumber.valid && this.mobileNo) {
      ctrl.setValue(this.mobileNo);
    } else {
      ctrl.setValue(null);
    }
  }
}